import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=bcf9ea8e&"
import script from "./FormHeader.vue?vue&type=script&lang=ts&"
export * from "./FormHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcf9ea8e')) {
      api.createRecord('bcf9ea8e', component.options)
    } else {
      api.reload('bcf9ea8e', component.options)
    }
    module.hot.accept("./FormHeader.vue?vue&type=template&id=bcf9ea8e&", function () {
      api.rerender('bcf9ea8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Leasing/FormHeader.vue"
export default component.exports